import { Link } from "../models"

export class EventCategory {
	public storageId: string;
	public uuid: string;
	public name: string;
	public fullDescription: string
	public assignable: boolean;

	public _links: {
		self: Link
	}
}



// WEBPACK FOOTER //
// ./src/app/models/event-category.model.ts